import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font, media } from '../theme/base/mixins';
import { StyledLIComponent, StyledUListComponent } from '../types';
import { Icon } from './Icon';

/**
 * props:
 * - inline -> for inlined items
 */

export const ListItem: StyledLIComponent = styled.li`
  ${font()};

  position: relative;
  padding: 5px 0;

  span {
    margin-left: 25px;
    display: inline-block;
  }

  ${Icon} {
    position: absolute;
    top: 5px;
    left: 0;

    canvas {
      width: 18px;
      height: 18px;
    }

    svg {
      fill: ${(props: ThemeProps<Theme>) => props.theme.colors.primary};
    }
  }

  ${media.medium`
    span {
      margin-left: 38px;
    }

    ${Icon} {
      top: 5px;
      width: 24px;
      height: 24px;

      svg {
        width: 24px;
        height: 24px;
      }
    }
  `}
`;

interface ListProps {
  inlined?: boolean;
}

export const List: StyledUListComponent<ListProps> = styled.ul`
  ${ListItem} {
    ${(props: ListProps) =>
      props.inlined &&
      css`
        display: inline;
      `};
  }
`;
